"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScormApi = exports.ScormDataItem = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
class ScormApiParseInfo {
}
;
class ScormDataItem {
    constructor(value, isReadOnly = false, isWriteOnly = false, save = true, allowedValues, isArray = false, children) {
        this.unchanged = true;
        this.value = value;
        this.isWriteOnly = isWriteOnly;
        this.isReadOnly = isReadOnly;
        this.save = save;
        this.allowedValues = allowedValues;
        this.isArray = isArray;
        this.children = children;
    }
}
exports.ScormDataItem = ScormDataItem;
class ScormApi {
    //#endregion Member Variables
    //#region Constructor
    constructor(historyObjectId, readOnlyMode, student_id, student_name, credit, lesson_mode, launch_data, scoData) {
        //#region Definitions
        this.dataStoreDefines = {
            "cmi": new ScormDataItem(undefined, true, false, false, undefined, false, "student_id, student_name, lesson_location, credit, lesson_status, entry, score, total_time, lesson_mode, exit, session_time"),
            "cmi.core.student_id": new ScormDataItem(undefined, true, false, false),
            "cmi.core.student_name": new ScormDataItem(undefined, true, false, false),
            "cmi.core.lesson_location": new ScormDataItem(""),
            "cmi.core.credit": new ScormDataItem(undefined, true, false, false, ["credit", "no-credit"]),
            "cmi.core.lesson_status": new ScormDataItem("not attempted", false, false, true, ["passed", "completed", "failed", "incomplete", "browsed", "not attempted"]),
            "cmi.core.entry": new ScormDataItem("ab-initio", true, false, true, ["ab-initio", "resume", ""]),
            "cmi.core.score": new ScormDataItem("", false, true, false, undefined, false, "raw, min, max"),
            "cmi.core.score.raw": new ScormDataItem(""),
            "cmi.core.score.max": new ScormDataItem(""),
            "cmi.core.score.min": new ScormDataItem(""),
            "cmi.core.total_time": new ScormDataItem("0000:00:00.00", true),
            "cmi.core.lesson_mode": new ScormDataItem(undefined, true, false, false, ["browse", "normal", "review"]),
            "cmi.core.exit": new ScormDataItem(undefined, false, true, true, ["time-out", "suspend", "logout", ""]),
            "cmi.core.session_time": new ScormDataItem(undefined, false, true, false),
            "cmi.suspend_data": new ScormDataItem(""),
            "cmi.launch_data": new ScormDataItem(undefined, true, false, false),
            "cmi.comments": new ScormDataItem(""),
            "cmi.comments_from_lms": new ScormDataItem("", true),
            "cmi.objectives": new ScormDataItem(undefined, true, false, false, undefined, true, "id,score,status"),
            "cmi.objectives.n.id": new ScormDataItem(""),
            "cmi.objectives.n.score": new ScormDataItem("", true, false, false, undefined, false, "raw,min,max"),
            "cmi.objectives.n.score.raw": new ScormDataItem(""),
            "cmi.objectives.n.score.min": new ScormDataItem(""),
            "cmi.objectives.n.score.max": new ScormDataItem(""),
            "cmi.objectives.n.status": new ScormDataItem(undefined, false, false, true, ["passed", "completed", "failed", "incomplete", "browsed", "not attempted"]),
            "cmi.interactions": new ScormDataItem(undefined, true, false, false, undefined, true, "id,objectives,time,type,correct_responses,weighting,student_response,result,latency"),
            "cmi.interactions.n.id": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.objectives": new ScormDataItem(undefined, true, false, false, undefined, true, "id"),
            "cmi.interactions.n.objectives.n.id": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.time": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.type": new ScormDataItem(undefined, false, true, true, ["true-false", "choice", "fill-in", "matching", "performance", "sequencing", "likert", "numeric"]),
            "cmi.interactions.n.correct_responses": new ScormDataItem(undefined, true, false, false, undefined, true, "pattern"),
            "cmi.interactions.n.correct_responses.n.pattern": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.weighting": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.student_response": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.result": new ScormDataItem(undefined, false, true),
            "cmi.interactions.n.latency": new ScormDataItem(undefined, false, true),
        };
        this.errorCodes = {
            "0": "No error",
            "101": "General Exception",
            "201": "Invalid argument number",
            "202": "Element cannot have children",
            "203": "Element not an array. Cannot have count.",
            "301": "Not initialized",
            "401": "Not implemented error",
            "402": "Invaid set error, element is a keyword",
            "403": "Element is read only",
            "404": "Element is write only",
            "405": "Incorrect Data Type",
        };
        this.m_dataStore = {};
        this.m_dataStoreVersion = 0;
        this.m_dataStoreVersionCommited = 0;
        this.m_lastErrorCode = "0";
        this.m_lastErrorDiagnostic = "";
        this.m_initialized = false;
        this.m_commitList = [Promise.resolve()];
        this.m_ignoreFurtherCommits = false;
        this.m_historyObjectId = historyObjectId;
        this.m_readOnlyMode = readOnlyMode;
        this.SetScoData(scoData);
        this.m_dataStore["cmi.core.student_id"] = student_id;
        this.m_dataStore["cmi.core.student_name"] = student_name;
        if (credit)
            this.m_dataStore["cmi.core.credit"] = "credit";
        else
            this.m_dataStore["cmi.core.credit"] = "no-credit";
        if (this.dataStoreDefines["cmi.core.lesson_mode"].allowedValues)
            if ($.inArray(lesson_mode, this.dataStoreDefines["cmi.core.lesson_mode"].allowedValues) === -1)
                throw new Error(lesson_mode + " is an unallowed value for lesson_mode (" + this.dataStoreDefines["cmi.core.lesson_mode"].allowedValues.join(" ") + ")");
        if (launch_data == undefined)
            this.m_dataStore["cmi.launch_data"] = "";
        else
            this.m_dataStore["cmi.launch_data"] = launch_data;
        this.m_dataStoreVersion++;
    }
    //#endregion Constructor
    //#region Member Methods
    waitForLastCommit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.m_commitList.length > 0)
                yield this.m_commitList[this.m_commitList.length - 1];
        });
    }
    set ignoreFurtherCommits(val) {
        if (this.m_ignoreFurtherCommits === false && val === true)
            this.m_ignoreFurtherCommits = val;
    }
    //#region SCO To LMS Communications API
    LMSInitialize(parameter) {
        // synUtil.Notifications.info("SynerisLMS: LMSInitialize");
        this.SetError("0", "");
        this.m_initialized = true;
        // ToDo
        return "true";
    }
    LMSGetValue(parameter) {
        // synUtil.Notifications.info("SynerisLMS: LMSGetValue: " + parameter);
        this.SetError("0", "");
        if (!this.m_initialized) {
            this.SetError("301", "");
            return "";
        }
        // parse element
        let parseInfo = this.ParseGetSetParameter(parameter);
        // _version handling
        if (parseInfo.keyword === "_version") {
            if (parseInfo.elementName === "cmi.core") {
                return "3.4";
            }
            else {
                this.SetError("401", "");
                return "";
            }
        }
        // does the element exists?
        if (this.dataStoreDefines[parseInfo.elementNameDefine] == undefined) {
            this.SetError("401", "");
            return "";
        }
        // _children handling
        if (parseInfo.keyword === "_children") {
            if (this.dataStoreDefines[parseInfo.elementNameDefine].children != undefined) {
                return this.dataStoreDefines[parseInfo.elementNameDefine].children;
            }
            else {
                this.SetError("202", "");
                return "";
            }
        }
        // is element write only?
        if (this.dataStoreDefines[parseInfo.elementNameDefine].isWriteOnly) {
            this.SetError("404", "");
            return "";
        }
        // _count handling
        if (parseInfo.keyword === "_count") {
            if (this.dataStoreDefines[parseInfo.elementNameDefine].isArray) {
                let maxIndex = -1;
                for (let key in this.m_dataStore) {
                    if (key.substring(0, parseInfo.elementName.length) === parseInfo.elementName) {
                        let index = key.substring(parseInfo.elementName.length + 1).split(".")[0];
                        if (index != undefined && index !== "" && !isNaN(+index)) {
                            maxIndex = +index > maxIndex ? +index : maxIndex;
                        }
                    }
                }
                // todo return element.value.length;
                return maxIndex + 1;
            }
            else {
                this.SetError("401", "");
                return "";
            }
        }
        if (this.m_dataStore.hasOwnProperty(parseInfo.elementName)) {
            return this.m_dataStore[parseInfo.elementName];
        }
        else {
            return this.dataStoreDefines[parseInfo.elementNameDefine].value;
        }
    }
    LMSSetValue(parameter, value) {
        this.SetError("0", "");
        if (!this.m_initialized) {
            this.SetError("301", "");
            return "false";
        }
        // parse element
        let parseInfo = this.ParseGetSetParameter(parameter);
        // is keyword?
        if (parseInfo.keyword != undefined) {
            this.SetError("402", "");
            return "false";
        }
        // does the element exists?
        if (this.dataStoreDefines[parseInfo.elementNameDefine] == undefined) {
            this.SetError("401", "");
            return "false";
        }
        // is element read only?
        if (this.dataStoreDefines[parseInfo.elementNameDefine].isReadOnly) {
            this.SetError("403", "");
            return "false";
        }
        // correct value format?
        if (this.dataStoreDefines[parseInfo.elementNameDefine].allowedValues != undefined
            && $.inArray(value, this.dataStoreDefines[parseInfo.elementNameDefine].allowedValues) === -1) {
            this.SetError("405", "");
            return "false";
        }
        this.m_dataStore[parseInfo.elementName] = value;
        this.dataStoreDefines[parseInfo.elementNameDefine].unchanged = false;
        // special cross element behaviour
        if (parseInfo.elementName === "cmi.core.exit") {
            if (value === "suspended")
                this.m_dataStore["cmi.core.entry"] = "resume";
            else
                this.m_dataStore["cmi.core.entry"] = "";
        }
        this.m_dataStoreVersion++;
        return "true";
    }
    LMSCommit(parameter) {
        if (this.m_ignoreFurtherCommits === false) {
            this.SetError("0", "");
            if (!this.m_initialized) {
                this.SetError("301", "");
                return "false";
            }
            if (this.m_dataStoreVersion > this.m_dataStoreVersionCommited)
                this.CommitDataStore();
            return "true";
        }
    }
    LMSFinish(parameter) {
        // synUtil.Notifications.info("SynerisLMS: LMSFinish: " + parameter);
        this.SetError("0", "");
        if (!this.m_initialized) {
            this.SetError("301", "");
            return "false";
        }
        if (this.m_dataStore["cmi.core.lesson_status"].unchanged)
            this.m_dataStore["cmi.core.lesson_status"] = "completed";
        this.m_dataStore["cmi.core.total_time"] = this.Seconds2ScormTime(this.ScormTime2Seconds(this.m_dataStore["cmi.core.total_time"]) + this.ScormTime2Seconds(this.m_dataStore["cmi.core.session_time"]));
        this.m_dataStoreVersion++;
        this.LMSCommit("");
        // ToDo
        this.m_initialized = false;
        return "true";
    }
    LMSGetLastError() {
        // synUtil.Notifications.info("SynerisLMS: LMSGetLastError");
        return this.m_lastErrorCode;
    }
    LMSGetErrorString(errorCode) {
        // synUtil.Notifications.info("SynerisLMS: LMSGetErrorString: " + errorCode);
        if (this.errorCodes[errorCode] != undefined)
            return this.errorCodes[errorCode];
        else
            return "unknown error code";
    }
    LMSGetDiagnostic(parameter) {
        // synUtil.Notifications.info("SynerisLMS: LMSGetDiagnostic: " + parameter);
        return this.m_lastErrorDiagnostic;
    }
    //#endregion SCO To LMS Communications API
    //#region Helpers
    InitDataStore() {
        for (let key in this.dataStoreDefines) {
            this.m_dataStore[key] = this.dataStoreDefines[key].value;
        }
    }
    SetError(errorCode, errorDiagnostic) {
        this.m_lastErrorCode = errorCode;
        this.m_lastErrorDiagnostic = errorDiagnostic;
    }
    CommitDataStoreCoreAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let version = this.m_dataStoreVersion;
            let guid = Utilities_1.synUtil.getGUID(true);
            try {
                yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("LmsScormSaveScoData") + this.m_historyObjectId + "/",
                    method: "POST",
                    requestData: this.GetScoData()
                });
                this.m_dataStoreVersionCommited = version;
            }
            catch (err) {
                this.SetError("101", "Error during Commit");
                throw err;
            }
        });
    }
    CommitDataStore() {
        let that = this;
        // Might be a readonly SCORM session (i.e. when user executes a SCORM packages without having a history object assigned for that package)
        if (that.m_readOnlyMode)
            return;
        that.m_commitList.push(that.CommitDataStoreCoreAsync());
    }
    GetScoData() {
        let scoData = {};
        for (let key in this.m_dataStore) {
            let parseInfo = this.ParseGetSetParameter(key);
            if (this.dataStoreDefines[parseInfo.elementNameDefine].save)
                scoData[key] = this.m_dataStore[key];
        }
        return JSON.stringify(scoData);
    }
    SetScoData(scoData) {
        if (scoData != undefined && scoData !== "") {
            let data = JSON.parse(scoData);
            for (let key in data)
                this.m_dataStore[key] = data[key];
        }
    }
    ParseGetSetParameter(parameter) {
        let parseInfo = {
            elementName: "",
            elementNameDefine: "",
            keyword: undefined
        };
        let parameters = parameter.split(".");
        for (let i = 0; i < parameters.length; i++) {
            let part = parameters[i];
            if ($.inArray(part, ["_version", "_count", "_children"]) !== -1) {
                parseInfo.keyword = part;
                break;
            }
            else if (!isNaN(+part)) {
                parseInfo.elementName += (parseInfo.elementName !== "" ? "." : "") + parameters[i];
                parseInfo.elementNameDefine += (parseInfo.elementNameDefine !== "" ? "." : "") + "n";
            }
            else {
                parseInfo.elementName += (parseInfo.elementName !== "" ? "." : "") + parameters[i];
                parseInfo.elementNameDefine += (parseInfo.elementNameDefine !== "" ? "." : "") + parameters[i];
            }
        }
        return parseInfo;
    }
    ScormTime2Seconds(scormTime) {
        if (scormTime) {
            let parts = scormTime.split(":");
            return +parts[0] * 3600 + +parts[1] * 60 + +parts[2];
        }
        return 0;
    }
    Seconds2ScormTime(seconds) {
        let hours = seconds / 3600;
        let minutes = (hours - Math.floor(hours)) * 60;
        let sec = (minutes - Math.floor(minutes)) * 60;
        let hoursStr = Math.floor(hours).toString();
        let scormTime = "";
        for (let i = hoursStr.length; i < 4; i++)
            scormTime += "0";
        scormTime += hoursStr + ":";
        let minutesStr = Math.floor(minutes).toString();
        for (let i = minutesStr.length; i < 2; i++)
            scormTime += "0";
        scormTime += minutesStr + ":";
        let secStr = sec.toPrecision(4);
        for (let i = secStr.indexOf("."); i < 2; i++)
            scormTime += "0";
        scormTime += secStr;
        return scormTime;
    }
}
exports.ScormApi = ScormApi;
